<template>
  <div class="box">
      <the-header class="hd"></the-header>
    <div class="login-card">
      <div class="title">修改密码</div>
      <span class="label">输入原密码</span>
      <div class="row">
        <el-input
          @keyup.enter.native="login"
          placeholder="请输入原密码"
          show-password
          type="password"
          v-model="oldPass"
        ></el-input>
      </div>
      <span class="label">输入新密码</span>
      <div class="row">
        <el-input
          @keyup.enter.native="login"
          placeholder="请输入新密码"
          show-password
          type="password"
          v-model="newPass"
        ></el-input>
      </div>
      <span class="label">再次输入新密码</span>
      <div class="row">
        <el-input
          @keyup.enter.native="login"
          placeholder="请输入再次输入新密码"
          ref="pwd"
          show-password
          type="password"
          v-model="confirmPass"
        ></el-input>
        <div @click="clearPwd" class="close" v-if="showTips">×</div>
        <div class="tips" v-if="showTips">两次输入密码不一致，请重新输入</div>
      </div>
      <div class="row btn">
        <el-button
          @click="$router.back()"
          plain
          type="primary"
        >取消</el-button>
        <el-button
          :disabled="isLoging"
          @click="updataPwd"
          type="primary"
        >确认</el-button>
      </div>
    </div>
    <div
      class="footer-text"
    >Copyright @ 2018-2038 全息云通健康科技有限公司版权所有</div>
  </div>
</template>
<script>
// import storage from '@/model/utils/localStorage'
import UserService from '@/model/api/login'
import TheHeader from '@/view/components/TheHeader'
export default {
  name: 'EditPwd',
  components:{
      TheHeader,
  },
  data() {
    return {
      oldPass: '',
      confirmPass: '',
      newPass: '',
      isLoging: false,
      showTips: false
    }
  },
  methods: {
    updataPwd() {
        const oldPass = this.oldPass
        const newPass = this.newPass
        const confirmPass= this.confirmPass
        if (!confirmPass|| !newPass || !oldPass) return
        if (confirmPass!== newPass) {
            this.showTips = true
            return
        }

        this.isLoging = true
        this.showTips = false
        let params = {
            type: 1,
            newPass: newPass,
            confirmPass: confirmPass,
            oldPass: oldPass
        }
        UserService.editPwd(params).then(() => {
            this.isLoging = false
            // 这里需要刷新页面，重新载入 HeaderBar 组件
            this.$message.success('密码修改成功！')
            this.$router.push('/editsuccess')
            // setTimeout(() => {
            //     storage.clear()
            //     window.location.reload()
            // },1000)
            })
            .catch(() => {
                this.isLoging = false
            })
        },
        clearPwd() {
            this.newPass= ''
            this.$refs.pwd.focus()
            this.showTips = false
        }
    }
}
</script>
<style lang="scss" scoped>
.box {
    position: absolute;
  z-index: 1;
  height: 100%;
  width: 100vw;
  background-color: #f1f2f7;
  .hd{
    height: 56px;
    width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    line-height: 56px;
}
  .login-card {
    border: 1px solid $primary;
    position: relative;
    top: 50%;
    margin: 0 auto;
    padding: 40px 0;
    padding-bottom: 80px;
    width: 520px;
    transform: translateY(-50%);
    // background: rgba(255, 255, 255, 0.6);
    border-radius: 8px;
    .title {
      text-align: center;
      font-size: 20px;
      line-height: 28px;
      color: #333;
    }
    .label {
      margin-right: 10px;
      width: 200px;
      color: #778899;
      font-size: 16px;
      text-align: right;
      display: inline-block;
    }
    .row {
      position: relative;
      margin-top: 30px;
      padding-left: 50px;
      padding-right: 20px;
      width: 250px;
      height: 50px;
      border: 1px solid $primary;
      border-radius: 3px;
      line-height: 50px;
      background: linear-gradient(
        to right,
        $primary 0,
        $primary 50px,
        white 50px,
        white 100%
      );
      display: inline-block;
      .close {
        position: absolute;
        top: 17px;
        right: 10px;
        width: 16px;
        height: 16px;
        font-size: 22px;
        text-align: center;
        line-height: 8px;
        color: $primary;
        display: block;
        cursor: pointer;
      }
      .tips {
        position: absolute;
        top: 0;
        right: -270px;
        padding: 0 20px;
        width: 250px;
        height: 50px;
        color: white;
        line-height: 50px;
        border-radius: 10px;
        background-color: $orange;
        &:before {
          position: absolute;
          top: 21px;
          left: -4px;
          content: '';
          border-radius: 3px;
          border: 5px solid;
          border-color: $orange transparent transparent $orange;
          transform: rotate(-45deg);
          display: block;
        }
      }
      &:before {
        content: '';
        position: absolute;
        left: 9px;
        top: 9px;
        width: 32px;
        height: 32px;
        display: block;
        background-image: url('~@/assets/images/icons/login/pwd.png');
        background-repeat: no-repeat;
        background-size: 32px auto;
        background-position-x: 0;
      }
      &:nth-child(3):before {
        background-image: url('~@/assets/images/icons/login/pwd.png');
      }
      &.btn {
        margin: 0 auto;
        margin-top: 40px;
        width: 100%;
        padding: 0;
        border: 0;
        background: none;
        display: inline-block;
        text-align: center;
        &:before {
          display: none;
        }
        .el-button {
          width: 140px;
        }
      }
    }
    .el-button {
      width: 100%;
      height: 100%;
      font-size: 16px;
      border-radius: 4px;
    }
  }
  .footer-text {
    position: absolute;
    bottom: 20px;
    width: 100%;
    color: #999;
    text-align: center;
    line-height: 20px;
    height: 20px;
  }
}
/deep/ .row {
  .el-input {
    height: 100%;
    display: block;
    &__inner {
      font-size: 14px;
      height: 46px;
      border: 0;
      vertical-align: top;
      box-shadow: none;
    }
  }
  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #bcbcbc;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #bcbcbc;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #bcbcbc;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #bcbcbc;
  }
}
</style>